<template>
  <span class="message-room">
    <a-badge dot>
      <a-button size="small" icon="el-icon-chat-round" @click="showDrawer" shape="round">
        <span class="hidden-sm-and-down">問甜課/回報Bug</span>
        <a-icon type="message"/>
      </a-button>
    </a-badge>
    <el-drawer
        size="70%"
        :modal="false"
        :visible.sync="isDrawerOpen"
        :with-header="false"
        :show-close="false"
    >
      <el-container>
        <el-main>

      <el-table
          :data="messages"
          style="width: 100%"
          empty-text="沒有訊息"
          row-class-name="message-box"
          max-height="600"
      >
        <el-table-column prop="content" label="課程心得聊天室">
          <template slot-scope="scope">
      <el-icon v-show="isLoading" class="el-icon-loading"/>
            {{ scope.row.sender }}<br>
                <el-card :body-style="{ padding: '10px' }"
                         style="border-radius: 20px"
                         :type="scope.row.sender === userName ? 'info' : 'success'">{{ scope.row.content }}</el-card>

              <div style="opacity: .5; font-size: 6px">{{ scope.row['時間戳記'] }}</div>

          </template>
        </el-table-column>
      </el-table>
        </el-main>
        <el-footer>
          <div>
            <el-input type="textarea" :autosize="true" :disabled="false"
                      :placeholder="this.user.loginInfo.login ? `以${this.userName} 發表` : '匿名留言' " v-model="message"/>
            <el-button style="width:100%" :disabled="message.length === 0" @click="sendMessage" round slot="suffix"
                       class="el-icon-s-promotion"/>
          </div>
        </el-footer>
      </el-container>

    </el-drawer>
  </span>
</template>
<script>
let proxy = "https://cors-anywhere.herokuapp.com/"
let sheetId = '1Hc747yTIiMghbF4ZjHYLuQT-98NwKTvsAH6qWFt_Aew'
let sheetTableId = "o63g0x1"
let desturl = proxy +
    "https://spreadsheets.google.com/feeds/list/" + sheetId + "/" + sheetTableId + "/public/values?alt=json"
let inboxUrl = proxy + "http://docs.google.com/forms/d/e/1FAIpQLSf7scJrM7U88pLlKcWHRhCzo1zReKr8TuP0F_hzSv9216RoFw/formResponse"
import axios from 'axios'

export default {
  name: 'message-room',
  data() {
    return {
      isDrawerOpen: false,
      messages: [{'sender': "讀取中", 'content': "修但幾勒.../ 小等一下..."}],
      message: '',
      inboxUrl: inboxUrl,
      isLoading: false
    }
  },
  methods: {
    showDrawer() {
      this.isDrawerOpen = true
      this.loadRemote()
    },
    async loadRemote() {
      this.isLoading = true
      let resp = await axios.get(desturl)
          .catch(function (e) {
            this.$notify({
              title: '無法讀取聊天室內容',
              message: e,
              type: 'danger'
            })
          })
      // console.log(resp)
      let rawMessage = resp.data.feed.entry
      let messages = []
      for (let rm of rawMessage) {
        let m = {}
        for (let rmkey in rm) {
          if (rmkey.includes('gsx$')) {
            m[rmkey.split('gsx$')[1]] = rm[rmkey]['$t']
          }
          if (rmkey.includes('gsx$')) {
            m[rmkey.split('gsx$')[1]] = rm[rmkey]['$t']
          }
        }
        messages.push(m)
      }
      this.messages = messages.reverse()

      this.isLoading = false
    },
    sendMessage() {
      let message = this.message
      let displayName = this.userName
      this.messages.unshift({'sender': displayName, 'content': message})
      let d = {'entry.1060195956': displayName, 'entry.426088393': message}
      console.log(d)
      axios({method: 'get', url: inboxUrl, params: d}
      ).then(() => this.loadRemote())
          .catch((e) => this.$notify({
            title: '無法送出訊息',
            message: e,
            type: 'danger'
          }))
      this.message = ''
    }
  },
  computed: {
    userName() {
      return `${(this.user.displayName ?? '').length > 0 ? this.user.displayName : this.user.loginInfo.name} ${this.user.dep} ${this.user.grade}`
    }
  },
  created() {
  }
}
</script>
<style>

.message-box {
  display: flex;
  justify-content: flex-start;
  alignment: right;
}

.sender {
  text-align: right;
}
</style>
